import {
  AirDisruptionGuardsV1,
  CartGuards,
  CfarGuards,
  AirChfarGuards,
  ContactInformationGuards,
  FlightPassengerGuardsV2,
  AirPFExerciseGuards,
  ReviewGuards,
  SeatGuards,
  VipSupportGuards,
  AirChfarExerciseDiscountGuards,
  getObjectKeysAsObject,
  BaggageGuards,
  AirCfarGuardsV2,
  AirPriceDropGuards,
} from "@hopper-b2b/checkout";
import { BagsAndSeatsGuards } from "../../../checkout/states/bagsAndSeats";
import { NubankPaymentGuards } from "../../../checkout/states/payments";
import { passengerInformationGuards } from "./passengerInformation";
import { paymentGuards } from "./payment";
import { seatsGuards } from "./seats";

export const Guards = {
  ...AirDisruptionGuardsV1,
  ...CartGuards,
  ...CfarGuards,
  ...AirChfarGuards,
  ...ContactInformationGuards,
  ...FlightPassengerGuardsV2,
  ...paymentGuards,
  ...AirPFExerciseGuards,
  ...ReviewGuards,
  ...SeatGuards,
  ...BagsAndSeatsGuards,
  ...VipSupportGuards,
  ...AirChfarExerciseDiscountGuards,
  ...NubankPaymentGuards,
  ...BaggageGuards,
  ...AirCfarGuardsV2,
  ...AirPriceDropGuards,
  ...seatsGuards,
  ...passengerInformationGuards,
};

export const GuardTypes = getObjectKeysAsObject(Guards);
